export class DateTimeFormat {
    static dateTime = "yyyy-MM-dd'T'TT";
    static fullYear = "dd-MM-yyyy";
    static monthSlash = "MM/yyyy";
    static monthDash = "MM-yyyy";

    // static dateMonth = "yyyy-MM"
}
